import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect } from "react";
import { ProfileContext } from "../../pages/profile";

function ModalCreateProject() {
  const {
    modalNew,
    setDataNewProject,
    setModalNew,
    dataNewProject,
    loadingButtonDelete,
    handlerNewProject,
  } = useContext(ProfileContext);

  useEffect(() => {
    if (modalNew) {
      setDataNewProject({ name: "", phone: "", web: "", email: "" });
    }
  }, [modalNew, setDataNewProject]); // Ejecuta esto cada vez que modalNew cambie

  return (
    <Modal
      open={modalNew}
      onClose={() => {
        setModalNew(false);
        setDataNewProject({ name: "", phone: "", web: "", email: "" });
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 350,
          bgcolor: "white",
          borderRadius: 3,
          boxShadow: 4,
          p: 2,
        }}
      >
        <Typography
          component="h2"
          variant="h5"
          sx={{ mb: 2, textAlign: "center" }}
        >
          Agregar Proyecto
        </Typography>
        <Stack component="form" spacing={2}>
          <TextField
            label="Nombre Proyecto"
            value={dataNewProject.name}
            onChange={({ target }) => {
              setDataNewProject({ ...dataNewProject, name: target.value });
            }}
          />
          <TextField
            label="Telefono"
            type="text" // Cambiamos a text para un mejor control
            value={dataNewProject.phone}
            onChange={({ target }) => {
              const onlyNums = target.value.replace(/[^0-9]/g, ""); // Solo permite números
              setDataNewProject({ ...dataNewProject, phone: onlyNums });
            }}
          />
          <TextField
            label="Correo Electrónico"
            type="email"
            value={dataNewProject.email}
            onChange={({ target }) => {
              setDataNewProject({ ...dataNewProject, email: target.value });
            }}
          />
          <TextField
            label="Página Web"
            value={dataNewProject.web}
            onChange={({ target }) => {
              setDataNewProject({ ...dataNewProject, web: target.value });
            }}
          />
          <Stack flexDirection="row" justifyContent="end">
            <Button
              onClick={() => {
                setModalNew(false);
              }}
              sx={{
                mr: 1.5,
              }}
            >
              CANCELAR
            </Button>
            <LoadingButton
              loading={loadingButtonDelete}
              variant="contained"
              sx={{ color: "white" }}
              onClick={(e) => {
                e.preventDefault(); // Prevenimos el comportamiento por defecto
                handlerNewProject(e); // Pasamos el evento a la función
                setDataNewProject({ name: "", phone: "", web: "", email: "" }); // Reiniciamos los campos
              }}
            >
              Agregar
            </LoadingButton>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
}

export default ModalCreateProject;
